import React, { FC, useState, useEffect } from "react";
import { Space, Typography } from "antd";
import { handleProductActionInfo } from "../../helpers/function.helper";
import { useParams } from "react-router-dom";
import { ProudctActionDetail } from "../../api/sku";
import { productdatahelperSingle } from "../../helpers/products.helper";
import { skuDatahelperSingle } from "../../helpers/sku.helper";
import { FormattedMessage } from "react-intl";
import { useGlobalState } from "../../context/Provider";

const ProductActionInfo: FC = () => {
  const { Title, Text } = Typography;
  let { skuId, activeSection }: any = useParams();
  const [info, setInfo] = useState<any>({});
  const [warehouseName, setWarehouseName] = useState<string>("");
  const { warehouserList }: any = useGlobalState();

  useEffect(() => {
    ProudctActionDetail(activeSection, skuId).then((res) => {
      if (res.status === 200) {
        activeSection === "sku"
          ? setInfo(skuDatahelperSingle(res.data))
          : setInfo(productdatahelperSingle(res.data));
      }
    });
  }, []);

  useEffect(() => {
    if (
      Object.entries(info).length &&
      warehouserList.data.length &&
      activeSection !== "sku"
    ) {
      const name = warehouserList.data.find(
        (item: any) => info.warehouseId === item.id
      ).name;
      setWarehouseName(name);
    }
  }, [info, warehouserList]);

  const {
    name,
    sku,
    manufacturerDisplayName: manufacture,
    creationTime,
  } = info;
  const reuslts = handleProductActionInfo(
    name,
    sku,
    manufacture,
    creationTime,
    warehouseName
  );

  return (
    <div className="info mb-4" style={{ lineHeight: "35px" }}>
      {Object.entries(reuslts).map((item: any) => (
        <Space align="center">
          <Title level={4} style={{ margin: "0" }}>
            <FormattedMessage id={item[0]} />
          </Title>
          :<Text style={{ margin: "0" }}> {item[1]}</Text>
        </Space>
      ))}
    </div>
  );
};

export default ProductActionInfo;
